module.exports = __webpack_public_path__ + "img/2.600aa285.png";